export class LoadReferralsTerms {
  public static type: string = '[HTTP] LoadReferralsTerms';
}
